import { FC } from 'react';
import {
	Box,
	Flex,
	Image,
	Text,
	Menu,
	MenuButton,
	MenuList,
	MenuItem,
	IconButton,
} from 'src/components/ui';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { ICatalog } from 'src/lib/schemas';
import { TActions } from 'src/components/common/DataTable';

const DEFAULT_IMAGE = 'https://img.clevup.in/static/placeholder.jpg';

interface ProductCardProps {
	product: ICatalog;
	onAction: (action: TActions, data: ICatalog) => void;
}

const ProductCard: FC<ProductCardProps> = ({ product, onAction }) => {
	return (
		<Box
			borderWidth="1px"
			borderColor="gray.200"
			borderRadius="lg"
			overflow="hidden"
			bg="white"
			transition="box-shadow 0.2s"
			_hover={{ boxShadow: 'md' }}
		>
			<Flex direction="column" h="100%">
				{/* Image Section */}
				<Box bg="gray.50" p={4} display="flex" justifyContent="center" alignItems="center" minH="150px">
					<Image
						src={product.image || DEFAULT_IMAGE}
						alt={product.name || 'Product image'}
						maxH="120px"
						maxW="100%"
						objectFit="contain"
					/>
				</Box>

				{/* Content Section */}
				<Flex direction="column" p={4} flex="1" gap={2}>
					<Flex justify="space-between" align="start">
						<Text fontWeight="semibold" fontSize="md" noOfLines={2}>
							{product.name}
						</Text>
						<Menu>
							<MenuButton
								as={IconButton}
								icon={<ChevronDownIcon />}
								variant="ghost"
								size="sm"
								aria-label="Actions"
								minW="auto"
							/>
							<MenuList>
								<MenuItem onClick={() => onAction('Edit', product)}>
									Edit
								</MenuItem>
								<MenuItem onClick={() => onAction('Delete', product)}>
									Delete
								</MenuItem>
								<MenuItem onClick={() => onAction('Create campaign', product)}>
									Create campaign
								</MenuItem>
							</MenuList>
						</Menu>
					</Flex>

					{product.url && (
						<Text fontSize="sm" color="gray.600" noOfLines={1} wordBreak="break-all">
							{product.url}
						</Text>
					)}
				</Flex>
			</Flex>
		</Box>
	);
};

export default ProductCard;
